/**
 * Lightweight error logger — logs to the browser console.
 * All functions preserve the same signatures so call sites don't need to change.
 */

export const logError = (error, context = {}, level = 'error') => {
	const msg = typeof error === 'string' ? error : (error?.message ?? String(error));
	const logFn = level === 'warning' ? console.warn : level === 'info' ? console.info : console.error;
	logFn(`[${level.toUpperCase()}]`, msg, context);
};

export const logReduxError = (action, user = null) => {
	if (!action?.type) return;
	const error = action.payload?.error || action.payload || `Action failed: ${action.type}`;
	logError(error, { actionType: action.type, payload: action.payload, user });
};

export const logQueueError = (error, queueItem, user = null) => {
	logError(error, { actionType: 'QUEUE_SEND_FAILED', queueItem, user }, 'warning');
};

export const logApiError = (error, requestInfo, user = null) => {
	const level = requestInfo?.status >= 500 ? 'error' : 'warning';
	logError(error, { request: requestInfo, user }, level);
};
